import React from "react";
import styles from "./Cases.module.css";
import { useNavigate } from "@tanstack/react-router";

interface CaseProps {
  id?: string;
  type?: number;
  price?: number;
  comingSoon?: boolean;
  pressed?: boolean;
}

export const Case: React.FC<CaseProps> = ({ id, type, price, comingSoon, pressed }) => {
  const navigate = useNavigate();

  const getCaseBackground = () => {
    switch (type) {
      case 5:
        return 'url("/fone/FiveCase.png")';
      case 7:
        return 'url("/fone/SevenCase.png")';
      case 10:
        return 'url("/fone/TeenCase.png")';
      default:
        return 'url("/fone/FiveCase.png")';
    }
  };

  const handleCaseClick = () => {
    if (comingSoon || pressed) return; // Блокируем клики по Coming Soon кейсам
    if (!id) return;
    navigate({ to: `/shop/select-case/case-page/${id}` });
  };

  return (
    <div className={styles.container}>
      <div
        className={`${styles.Cases} ${comingSoon ? styles.comingSoonCase : ''}`}
        onClick={handleCaseClick}
        style={{ 
          background: getCaseBackground(), 
          cursor: comingSoon ? "default" : "pointer" 
        }}
      >
        
        {comingSoon && (
          <div className={styles.comingSoonOverlay}>
            <span>COMING SOON</span>
          </div>
        )}
      </div>
      {price && (
        <div className={`${styles.price} ${comingSoon ? styles.comingSoonPrice : ''}`}>
          <svg
            width="35"
            height="32"
            viewBox="0 0 35 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={comingSoon ? { opacity: 0.5 } : {}}
          >
            <g filter="url(#filter0_dd_934_4595)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.5 32C26.3366 32 33.5 24.8366 33.5 16C33.5 7.16344 26.3366 0 17.5 0C8.66344 0 1.5 7.16344 1.5 16C1.5 24.8366 8.66344 32 17.5 32ZM19.5 6.00421V4H15.5V6.00501C13.9548 6.05558 12.7494 6.48937 11.8839 7.30638C10.9613 8.17729 10.5 9.43183 10.5 11.07V20.93C10.5 22.5682 10.9613 23.8227 11.8839 24.6936C12.7494 25.5106 13.9548 25.9444 15.5 25.995V28H19.5V25.9959C21.0399 25.9498 22.2453 25.5157 23.1161 24.6936C24.0387 23.802 24.5 22.5474 24.5 20.93V15.7356C24.5 15.2587 24.2533 15.0202 23.7598 15.0202H18.1276C17.677 15.0202 17.4517 15.2379 17.4517 15.6734V17.7885C17.4517 18.2239 17.677 18.4417 18.1276 18.4417H20.0586C20.2946 18.4417 20.4126 18.5557 20.4126 18.7838V20.7434C20.4126 21.4069 20.2732 21.8839 19.9943 22.1742C19.7153 22.4438 19.2326 22.5785 18.546 22.5785H16.454C15.7889 22.5785 15.3061 22.4438 15.0057 22.1742C14.7268 21.8839 14.5874 21.4069 14.5874 20.7434V11.2566C14.5874 10.5931 14.7268 10.1265 15.0057 9.85692C15.3061 9.56661 15.7889 9.42146 16.454 9.42146H18.546C19.2326 9.42146 19.7153 9.56661 19.9943 9.85692C20.2732 10.1265 20.4126 10.5931 20.4126 11.2566V12.0031C20.4126 12.4593 20.6379 12.6874 21.0885 12.6874H23.8241C24.2747 12.6874 24.5 12.4593 24.5 12.0031V11.07C24.5 9.45257 24.0387 8.2084 23.1161 7.33748C22.2453 6.49586 21.0399 6.05143 19.5 6.00421Z"
                fill={comingSoon ? "#aaa" : "#F2EB56"}
              />
            </g>
            <defs>
              <filter
                id="filter0_dd_934_4595"
                x="0.5"
                y="0"
                width="34"
                height="32"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="1" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.988235 0 0 0 0 0 0 0 0 0.266667 0 0 0 0.56 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_934_4595"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="-1" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0.996078 0 0 0 0 0.988235 0 0 0 0.64 0"
                />
                <feBlend
                  mode="normal"
                  in2="effect1_dropShadow_934_4595"
                  result="effect2_dropShadow_934_4595"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect2_dropShadow_934_4595"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
          <span style={comingSoon ? { opacity: 0.5 } : {}}>{price}</span>
        </div>
      )}
    </div>
  );
};
